import React, { useCallback, useEffect } from 'react';
import PollOpenResult from './Open/Result';
import PollRatingResult from './Rating/Result';
import PollStandardResult from './Standard/Result';

export default ({ poll, onCloseResultPoll, force, headerHidden }) => {

    const setViewedResult = useCallback(() => {
        if (poll && !force) {
            onCloseResultPoll(poll)
        }
    }, [poll, force])

    useEffect(() => {
        return () => setViewedResult()
    }, [])

    if (!force && poll.private && 'result' !== poll.status) {
        return null;
    }

    switch (poll.type) {
        case 'open':
            return <PollOpenResult poll={poll} fullPage={force} headerHidden={headerHidden} />;
        case 'rating':
            return <PollRatingResult poll={poll} headerHidden={headerHidden} />;
        default:
            return <PollStandardResult poll={poll} headerHidden={headerHidden} />;
    }
};
